var Api = require('./api');
var configPromise = require('../config').configPromise;

var SecurityApi = {

  resetPassword(data){
    return configPromise.then(function (config) {
      return Api.post(config.apiPath('/api/account/ForgotPassword'), data);
    });
  },

  saveNewPassword(data, token){
    var self = this;
    return configPromise.then(function (config) {
      return Api.post(config.apiPath('/api/account/ResetPassword?token={0}', [token]), data);
    });
  },

  activateAccount(data, token){
    return configPromise.then(function (config) {
      return Api.post(config.apiPath('/api/account/ActivateAccount?token={0}', [token]), data);
    });
  },

  validateActivateAccountToken(token){
    return configPromise.then(function (config) {
      return Api.post(config.apiPath('/api/account/VerifyActivateAccountToken?token={0}', [token]));
    });
  },

  validateResetPasswordToken(token){
    return configPromise.then(function (config) {
      return Api.post(config.apiPath('/api/account/VerifyResetPasswordToken?token={0}', [token]));
    });
  }


};

module.exports = SecurityApi;
